import CouponCode from './CouponCode';

export default CouponCode;
